import type { GeneratedReleaseNotes } from "@insights/contracts";

export async function copyGeneratedReleaseNotes(notes: GeneratedReleaseNotes) {
  if (
    typeof ClipboardItem !== "undefined" &&
    typeof navigator.clipboard?.write === "function" &&
    (typeof ClipboardItem.supports !== "function" ||
      ClipboardItem.supports("text/html"))
  ) {
    await navigator.clipboard.write([
      new ClipboardItem({
        "text/html": new Blob([notes.html], { type: "text/html" }),
        "text/plain": new Blob([notes.markdown], { type: "text/plain" }),
      }),
    ]);
    return;
  }
  await navigator.clipboard.writeText(notes.markdown);
}
